import { useContext } from 'react'

import { Divider, ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import GeneralConfigurationSkeleton from './GeneralConfigurationSkeleton/GeneralConfigurationSkeleton'
import useLogisticGeneralConfiguration from './hooks/useLogisticGeneralConfiguration/useLogisticGeneralConfiguration'
import PickingAndPackingSection from './PickingAndPackingSection/PickingAndPackingSection'
import ShippingFulfillmentSection from './ShippingFulfillmentSection/ShippingFulfillmentSection'
import ShippingLabelFormatSection from './ShippingLabelFormatSection/ShippingLabelFormatSection'
import * as Styles from './styles'

const GeneralConfiguration = () => {
  const { info, updateContext } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const {
    loading,
    data,
    hasChanges,
    resetData,
    onShipmentsConfigChange,
    onStoreFeaturesChange,
    onSaveChanges,
    editingShipmentsConfiguration,
    labelFormat,
  } = useLogisticGeneralConfiguration({
    storeId: info?.selectedStore?.id,
    setToastInfo,
    updateContext,
    returnPortalId: info?.selectedReturnPortal?.id,
  })
  const { hasPermission } = useUserPermissions()

  if (loading) {
    return <GeneralConfigurationSkeleton />
  }

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editLogistics)} />}
      <PickingAndPackingSection value={data?.shipping_skip_packing} onChange={onShipmentsConfigChange} />
      <Divider />
      <ShippingFulfillmentSection value={data?.shipping_fulfillment} onChange={onShipmentsConfigChange} />
      <Divider />
      <ShippingLabelFormatSection value={labelFormat} onChange={onStoreFeaturesChange} />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editLogistics) && hasChanges}
        onSave={onSaveChanges}
        onRevertChanges={resetData}
        loading={editingShipmentsConfiguration}
        disabled={editingShipmentsConfiguration}
      />
    </Styles.Container>
  )
}

export default GeneralConfiguration
